import './index.scss';
import React from 'react';
import { Navigate } from 'react-router-dom';
import PermissionChecker from '~/components/permission_checker';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import CenterPanel from './center_panel';
import { RecentActivityProvider } from './providers';
import RightPanel from './right_panel';
const RecentActivity = () => {
    const { useNewView } = useUser();
    if (useNewView) {
        return React.createElement(Navigate, { to: '/content-library', replace: true });
    }
    return (React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.VIEW_RECENT_ACTIVITIES], isRoute: true },
        React.createElement(RecentActivityProvider, null,
            React.createElement("div", { className: "recent-activity-container" },
                React.createElement("div", { className: "folder-title" }, "Recent Activity"),
                React.createElement("div", { className: "recent-activity-body" },
                    React.createElement(CenterPanel, null),
                    React.createElement(RightPanel, null))))));
};
export default RecentActivity;
